import React from 'react';
import { useSelector } from 'react-redux';
import { Oval } from 'react-loader-spinner';

const GlobalLoader = () => {
    const publishLoading = useSelector((state) => state.publishVideoOnYoutubeReducer?.loading);

    if (!publishLoading) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999, // Ensure it's on top of everything
        }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#ffffff"
                    secondaryColor="#f3f3f3"
                    ariaLabel="oval-loading"
                />
                <h2 style={{ color: '#fff', marginTop: '20px', fontSize: '1.8rem' }}>
                    Publishing Video Action in Process... Please wait.
                </h2>
            </div>
        </div>
    );
};

export default GlobalLoader;
